import { Form } from '@anytag/shared-atoms';
import { AutoManagedCampaignFormSchema } from './schema';
import { Template } from './Template';
import { AutoManagedCampaignFormProps, AutoManagedCampaignFormValues } from './types';
import { defaultAutoManagedCampaignFormValues, getDefaultAutoManagedCampaignFormValues } from './utils';

export const AutoManagedCampaignForm = ({
  onSubmit,
  defaultValues = defaultAutoManagedCampaignFormValues
}: AutoManagedCampaignFormProps) => (
  <Form.Provider<AutoManagedCampaignFormValues>
    onSubmit={onSubmit}
    defaultValues={defaultValues}
    zodSchema={AutoManagedCampaignFormSchema}
  >
    <Template />
  </Form.Provider>
);

export * from './types';
export { getDefaultAutoManagedCampaignFormValues };
